@if (person) {
    <a [routerLink]="href$ | async">{{ person.fullName }}</a>
} @else {
    N/A
}
